
        require('./index.scss');
        "use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _feedback = require("./model/service/feedback.js");

var _feedback2 = _interopRequireDefault(_feedback);

var _wxappHover = require("./wxapp-hover/wxapp-hover.js");

var _wxappHover2 = _interopRequireDefault(_wxappHover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _module = {
    $mod: $(".module-right-toolbar"),
    cityId: $(".module-right-toolbar").data("cityid"),
    ismp: $(".module-right-toolbar").data("mp"),
    // isShowWechatGroup: false,
    contactInfo: {
        cityId: $(".module-right-toolbar").data("cityid"),
        opca: $(".module-right-toolbar").data("opca"),
        pname: $(".module-right-toolbar").data("pname"),
        source: $(".module-right-toolbar").data("source"),
        infoid: $(".module-right-toolbar").data("infoid"),
        ismp: $(".module-right-toolbar").data("mp"),
        hotlinePhone: $(".module-right-toolbar").data("hotlinePhone"),
        contactMail: $(".module-right-toolbar").data("contactMail")
    },

    init: function init() {
        // this.initContactInfo();
        this.bindScroll();
        this.bindClick();
        // this.bindHover();
        this.loupanCompare();
        (0, _wxappHover2["default"])(this.$mod.find(".rt-item.wx"), this.$mod.find(".rt-item.wx .icon-text"), {}, "pages/router/main?cityId=" + (!this.cityId || this.cityId === "null" ? 1 : this.cityId) + "&fromFrontPC=1");
    },


    initContactInfo: function initContactInfo() {
        var that = this;

        _feedback2["default"].getFeedbackContact({
            cityId: this.cityId,
            ismp: this.ismp
        }, function (res) {
            if (res.code === "200") {
                (0, _assign2["default"])(that.contactInfo, res.data.contactPerson);
            }
        });
    },

    bindScroll: function bindScroll() {
        var that = this;
        var winHeight = $(window).height();
        var infoFix = _.throttle(function () {
            if ($(window).scrollTop() > 0) {
                that.$mod.removeClass("hide").addClass("show");
                // if(that.isShowWechatGroup){
                //     $(".wechat-group-qr-code").show();
                // }
            } else {
                that.$mod.removeClass("show").addClass("hide").find(".rt-item").removeClass("active");
                Event.trigger("shopping-cart", "shopping-cart-unfold");
                // $(".wechat-group-qr-code").hide();
            }
        });
        $(window).scroll(infoFix);
    },
    bindClick: function bindClick() {
        var that = this;

        this.$mod.find(".ruzhu").click(function () {
            Event.trigger("feedback-dialog_show", "ruzhu", that.contactInfo);
        });

        this.$mod.find(".feedback").click(function () {
            Event.trigger("feedback-dialog_show", "feedback", that.contactInfo);
        });

        this.$mod.find(".error").click(function () {
            Event.trigger("feedback-dialog_show", "error", that.contactInfo);
        });

        this.$mod.find(".gotop").click(function () {
            $("html,body").animate({
                scrollTop: 0
            }, 300);
        });

        // this.$mod.find(".wechat-group").click(function() {
        //     if($(".wechat-group-qr-code").is(':visible')){
        //         $(".wechat-group-qr-code").hide();
        //         that.isShowWechatGroup = false;
        //     }else {
        //         $(".wechat-group-qr-code").show();
        //         that.isShowWechatGroup = true;
        //     }
        // });
    },


    loupanCompare: function loupanCompare() {
        var that = this;
        // 对比
        that.$mod.find("[node-type='compare']").click(function () {
            if ($(this).hasClass("active")) {
                Event.trigger("shopping-cart", "shopping-cart-unfold");
                $(this).removeClass("active");
            } else {
                Event.trigger("shopping-cart", "shopping-cart-fold");
                $(this).addClass("active");
            }
        });
        Event.on("right-toolbar", function (cmd, data) {
            switch (cmd) {
                case "shopping-cart-fold":
                    that.$mod.find("[node-type='compare']").removeClass("active");
                    break;
                case "shopping-cart-unfold":
                    that.$mod.find("[node-type='compare']").addClass("active");
                    break;
                case "shopping-cart-count":
                    if (data == 0) {
                        that.$mod.find(".red-circle").hide();
                    } else {
                        setTimeout(function () {
                            that.$mod.find(".red-circle").text(data).show();
                        }, 300);
                    }
                    break;
                case "add-remove-compare":
                    if (data.count == 0) {
                        that.$mod.find(".red-circle").hide();
                    } else {
                        that.$mod.find(".red-circle").text(data.count).show();
                    }
                    break;
                case "delete-all-compare":
                    that.$mod.find(".red-circle").hide();
                    break;
                default:
                    break;
            }
        });
    }

    // bindHover() {
    //     this.$mod.find('.rt-item').hover(function () {
    //         $(this).addClass('cur').siblings().removeClass('cur');
    //     }, function () {
    //         $(this).removeClass('cur');
    //     })
    // }
};

_module.init();

exports["default"] = _module;;
    


// WEBPACK FOOTER //
// ./~/@front-end/common-module-vm/right-toolbar/index.js